import { __decorate } from "tslib";
import { Component, Vue } from "vue-facing-decorator";
import GcuAgreementScreenForm from "@/components/gcu/GcuAgreementScreenForm.vue";
let GcuAgreementScreen = class GcuAgreementScreen extends Vue {
  userAccept() {
    window.location.assign("/gcu/acceptGcu");
  }
};
GcuAgreementScreen = __decorate([Component({
  components: {
    GcuAgreementScreenForm
  }
})], GcuAgreementScreen);
export default GcuAgreementScreen;